import type { TFunction } from 'i18next';
import { ParametersEnum } from 'pages/dimensions/types';
import { dimensionsErrors } from 'pages/dimensions/const';
import { SHOULD_BE_MORE_THEN_ZERO } from 'pages/dimensions/forms/const';
import { getDimensionsErrors } from './get-dimensions-errors';

const ZERO = '0';

export const roomParametersValidation = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputValue: any,
  parameter: ParametersEnum,
  translate?: TFunction
) => {
  if (inputValue === ZERO)
    return translate ? translate('dimensionsErrors.shouldBeMoreThanZero') : SHOULD_BE_MORE_THEN_ZERO;
  if (!inputValue) {
    if (translate) {
      const errors = getDimensionsErrors(translate);
      return errors[parameter]?.required;
    }
    return dimensionsErrors[parameter]?.required;
  }
  return undefined;
};
